var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"myFiles",attrs:{"type":"file","accept":_vm.accept,"id":"file","multiple":""},on:{"change":_vm.previewFiles}}),_vm._v(" "),_c('p',{staticClass:"text-info",staticStyle:{"margin-top":"0px","margin-bottom":"20px"}},[_vm._v("Pressione o Ctrl para adicionar mais de um item.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-216188bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload-file/main.vue
// module id = 519
// module chunks = 0